import PropTypes from "prop-types";
import { Media } from "solar/components/Media";
import styles from "components/stay/HeroVideo.module.scss";
import Video from "components/shared/stays/Video";

export default function HeroVideo({
  videoSrc,
  videoSmallSrc,
  posterSrc,
  posterSmallSrc,
  posterLqipSrc,
}) {
  return (
    videoSrc && (
      <>
        <Media greaterThanOrEqual="lg">
          <div className={styles.visual}>
            <Video
              videoSrc={videoSrc}
              posterSrc={posterSrc}
              posterLqipSrc={posterLqipSrc}
              layout="responsive"
              objectFit="cover"
              muted
              autoPlay
              loop
            />
          </div>
        </Media>
        <Media lessThan="lg">
          <div className={styles.visual}>
            <Video
              videoSrc={videoSmallSrc || videoSrc}
              posterSrc={posterSmallSrc || posterSrc}
              posterLqipSrc={posterLqipSrc}
              layout="responsive"
              objectFit="cover"
              muted
              autoPlay
              loop
            />
          </div>
        </Media>
      </>
    )
  );
}

HeroVideo.propTypes = {
  videoSrc: PropTypes.string.isRequired,
  videoSmallSrc: PropTypes.string,
  posterSrc: PropTypes.string,
  posterSmallSrc: PropTypes.string,
  posterLqipSrc: PropTypes.string,
};
